export default __webpack_public_path__ + "static/media/pro-img.849b9343.png";